import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { isListOperator } from '@atlassianlabs/jql-ast';
import { Fragment, Slice } from 'prosemirror-model';
import { TextSelection } from 'prosemirror-state';
import getDocumentPosition from '../common/get-document-position';
import ReactPluginView from '../common/react-plugin-view';
import Autocomplete from './components/autocomplete';
import { AUTOCOMPLETE_PLUGIN_NAME, JQLAutocompletePluginKey } from './constants';

/**
 * Returns whether an opening parenthesis should be automatically inserted for this option (e.g. after a list operator)
 */
var shouldInsertOpeningParenthesis = function shouldInsertOpeningParenthesis(_ref) {
  var type = _ref.type,
    context = _ref.context,
    isListFunction = _ref.isListFunction;
  if (type === 'value' || type === 'function' || type === 'keyword') {
    var operator = context === null || context === void 0 ? void 0 : context.operator;
    if (operator && isListOperator(operator) && !(context !== null && context !== void 0 && context.isList) && !isListFunction) {
      return true;
    }
  }
  return false;
};
var AutocompletePluginView = /*#__PURE__*/function (_ReactPluginView) {
  _inherits(AutocompletePluginView, _ReactPluginView);
  var _super = _createSuper(AutocompletePluginView);
  function AutocompletePluginView(view, keymap, portalActions, enableRichInlineNodes) {
    var _this;
    _classCallCheck(this, AutocompletePluginView);
    _this = _super.call(this, portalActions, AUTOCOMPLETE_PLUGIN_NAME, 'main');
    _defineProperty(_assertThisInitialized(_this), "getComponent", function () {
      return Autocomplete;
    });
    _defineProperty(_assertThisInitialized(_this), "getInitialComponentProps", function () {
      return {
        keymap: _this.keymap,
        onClick: _this.onReplaceSuggestion
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onReplaceSuggestion", function (option) {
      var _option$replacePositi = _slicedToArray(option.replacePosition, 2),
        from = _option$replacePositi[0],
        to = _option$replacePositi[1];
      var transaction = _this.view.state.tr;
      transaction.setMeta(JQLAutocompletePluginKey, true);

      // Request query hydration if we are inserting a user node
      if (_this.enableRichInlineNodes && option.type === 'value' && option.valueType === 'user') {
        transaction.setMeta('hydrate', true);
      }
      var documentFrom = getDocumentPosition(transaction.doc, from);
      var documentTo = getDocumentPosition(transaction.doc, to);

      // Change current selection to the mapped replace position
      transaction.setSelection(TextSelection.create(transaction.doc, documentTo, documentFrom));

      // Replace selected range with the selected autocomplete option
      transaction.replaceSelection(_this.getSliceForSuggestion(option));
      _this.view.focus();
      _this.view.dispatch(transaction);
    });
    _defineProperty(_assertThisInitialized(_this), "getSliceForSuggestion", function (option) {
      var value = option.value,
        name = option.name,
        nameOnRichInlineNode = option.nameOnRichInlineNode,
        valueType = option.valueType,
        context = option.context;
      var nodes = [];
      if (shouldInsertOpeningParenthesis(option)) {
        nodes.push(_this.view.state.schema.text('('));
      }
      var textContent = _this.view.state.schema.text(value);
      if (!_this.enableRichInlineNodes) {
        nodes.push(textContent);
      } else {
        switch (valueType) {
          case 'user':
            {
              var attributes = {
                type: 'user',
                id: value,
                name: nameOnRichInlineNode !== null && nameOnRichInlineNode !== void 0 ? nameOnRichInlineNode : name,
                fieldName: context === null || context === void 0 ? void 0 : context.field
              };
              nodes.push(_this.view.state.schema.nodes.user.create(attributes, textContent));
              break;
            }
          default:
            {
              nodes.push(textContent);
              break;
            }
        }
      }
      return new Slice(Fragment.from(nodes), 0, 0);
    });
    _this.view = view;
    _this.keymap = keymap;
    _this.enableRichInlineNodes = enableRichInlineNodes;
    return _this;
  }
  _createClass(AutocompletePluginView, [{
    key: "isSameState",
    value: function isSameState(state, prevState) {
      return prevState.doc.eq(state.doc) && prevState.selection.eq(state.selection);
    }
  }]);
  return AutocompletePluginView;
}(ReactPluginView);
export { AutocompletePluginView as default };